/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { formatDateOnly, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RenameSimulationRequestBody
 */
export interface RenameSimulationRequestBody {
    /**
     * 
     * @type {string}
     * @memberof RenameSimulationRequestBody
     */
    simulationName: string | null;
}

/**
 * Check if a given object implements the RenameSimulationRequestBody interface.
 */
export function instanceOfRenameSimulationRequestBody(value: object): value is RenameSimulationRequestBody {
    if (!('simulationName' in value) || value['simulationName'] === undefined) return false;
    return true;
}

export function RenameSimulationRequestBodyFromJSON(json: any): RenameSimulationRequestBody {
    return RenameSimulationRequestBodyFromJSONTyped(json, false);
}

export function RenameSimulationRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): RenameSimulationRequestBody {
    if (json == null) {
        return json;
    }
    return {
        
        'simulationName': json['simulationName'],
    };
}

export function RenameSimulationRequestBodyToJSON(json: any): RenameSimulationRequestBody {
    return RenameSimulationRequestBodyToJSONTyped(json, false);
}

export function RenameSimulationRequestBodyToJSONTyped(value?: RenameSimulationRequestBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'simulationName': value['simulationName'],
    };
}

